import { ApplicationRef, ComponentRef, createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { AlertDialogComponent } from './alert-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class AlertDialogService {
    isOfflineAlertOpen: boolean = false;
    timeoutWarningRef: ComponentRef<AlertDialogComponent> | null = null;

    constructor(private appRef: ApplicationRef, private environmentInjector: EnvironmentInjector) { }

    public showAlert(title: string, message: string, btnOkText: string = 'OK'): Promise<boolean> {
        const dialogRef = this.attach(title, message, btnOkText);

        return new Promise<boolean>((resolve, reject) => {
            dialogRef.instance.confirm.subscribe(() => {
                this.detach(dialogRef);
                resolve(true);
            });
            dialogRef.instance.cancel.subscribe(() => {
                this.detach(dialogRef);
                reject();
            });
        });
    }

    public showOffline(): Promise<boolean> {
        // if (!this.isOfflineAlertOpen) {
        //   this.isOfflineAlertOpen = true;
        //   const modalRef = this.modalService.open(OfflineDetectedDialogComponent, {});
        //   return modalRef.result;
        // }
        return Promise.resolve(true);
    }

    public showTimeoutWarning() {
        const alert = {
            title: 'Session Idle on Other Tab',
            message: `Your session from another tab has been inactive for an
      extended period of time. To prevent being logged out, select the
      inactive tab and indicate that you want to continue the session.`
        };

        this.timeoutWarningRef = this.attach(alert.title, alert.message, 'OK');
        this.timeoutWarningRef.instance.confirm.subscribe(() => this.closeTimeoutWarning());
        this.timeoutWarningRef.instance.cancel.subscribe(() => this.closeTimeoutWarning());
    }

    public closeTimeoutWarning() {
        if (this.timeoutWarningRef) {
            this.detach(this.timeoutWarningRef);
            this.timeoutWarningRef = null;
        }
    }

    // aurora-modal is a native <dialog> that supplies its own backdrop, so it is attached straight
    // to the document rather than hosted inside an NgbModal window.
    private attach(title: string, message: string, btnOkText: string): ComponentRef<AlertDialogComponent> {
        const dialogRef = createComponent(AlertDialogComponent, { environmentInjector: this.environmentInjector });
        dialogRef.setInput('title', title);
        dialogRef.setInput('message', message);
        dialogRef.setInput('btnOkText', btnOkText);

        document.body.appendChild(dialogRef.location.nativeElement);
        this.appRef.attachView(dialogRef.hostView);

        return dialogRef;
    }

    private detach(dialogRef: ComponentRef<AlertDialogComponent>) {
        const host = dialogRef.location.nativeElement as HTMLElement;
        this.appRef.detachView(dialogRef.hostView);
        dialogRef.destroy();
        host.remove();
    }
}
